import { THEME } from '../app.config'
import { useGeneralStore } from './stores/general'
export default {
  init() {
    const generalStore = useGeneralStore()
    // ### THEME Init
    const val = localStorage.getItem('theme')
    //const theme = val || THEME
    const theme = 'light'
    generalStore.TOGGLE_THEME(theme)
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (localStorage.getItem('theme') === 'system') {
        generalStore.TOGGLE_THEME('system')
      }
    })
    // ###  THEME Init End
  }
}
